import React, { useEffect, Component } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Donate from "./pages/Donate";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";
import Contact from "./pages/Contact";
import Update from "./pages/Update";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { motion, AnimatePresence } from "framer-motion";
import i18n from "./i18n";

// Error Boundary Component
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mx-auto p-4 text-center">
          <h1 className="text-2xl font-bold text-red-600">Something went wrong.</h1>
          <p>Please refresh the page or contact support.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const location = useLocation();
  const pathLang = location.pathname.split("/")[1];
  const validLangs = ["en", "ar"];
  const currentLang = validLangs.includes(pathLang) ? pathLang : localStorage.getItem("i18nextLng") || "en";

  useEffect(() => {
    localStorage.setItem("i18nextLng", currentLang);
    if (currentLang !== i18n.language) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang]);

  return (
    <ErrorBoundary>
      <div className="min-h-screen">
        <Navbar />
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="relative"
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:lang" element={<Home />} />
              <Route path="/:lang/services" element={<Services />} />
              <Route path="/:lang/donate" element={<Donate />} />
              <Route path="/:lang/signin" element={<SignIn />} />
              <Route path="/:lang/signup" element={<SignUp />} />
              <Route path="/:lang/profile" element={<Profile />} />
              <Route path="/:lang/contact" element={<Contact />} />
              <Route path="/:lang/update" element={<Update />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
        <Footer />
        <ScrollToTop />
      </div>
    </ErrorBoundary>
  );
}

export default App;